module.exports = __webpack_public_path__ + "img/_2.bf53acda.png";